import { createRouter, createWebHistory } from 'vue-router';
import MerchantForm from '../components/MerchantForm.vue'; // 商家表单组件
import QRCodePage from '../components/QRCodeGenerator.vue';      // 二维码页面
import CustomerReview from '../components/CustomerReview.vue'; // 顾客评价组件

const routes = [
    { path: '/', component: MerchantForm },
    { path: '/customer-review', component: CustomerReview },
    { path: '/codePage', component: QRCodePage }

];

const router = createRouter({
    history: createWebHistory(),
    routes
});

export default router;
